import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'INVIT_CLIENT',
  title: 'Come faccio a dare accesso alla mia cartella ai miei clienti?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Prima di tutto, il tuo cliente non deve aderire alla piattaforma per avere accesso alla piattaforma. Per dargli accesso alla tua cartella, basta cercarla e invitarla seguendo lo schema sottostante.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Vai alla scheda «Clienti»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INVIT_CLIENT/IT_INVIT_CLIENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Fare clic sul pulsante blu «Aggiungere un cliente» in alto a destra dello schermo.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INVIT_CLIENT/IT_INVIT_CLIENT_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Cerca «il tuo cliente» nella barra di ricerca.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INVIT_CLIENT/IT_INVIT_CLIENT_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Il vostro cliente compare nella lista? Un singolo scatto sopra la aggiunge alla vostra lista del cliente.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INVIT_CLIENT/IT_INVIT_CLIENT_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '5.',
    value: 'Il suo cliente non appare nella lista? Clicchi su «Invitare l\'impresa "Nome dell\'impresa" ad unirsi alla rete».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INVIT_CLIENT/IT_INVIT_CLIENT_5.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '6.',
    value: 'Poi inserisci le informazioni.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INVIT_CLIENT/IT_INVIT_CLIENT_6.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '7.',
    value: 'Confermare !'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INVIT_CLIENT/IT_INVIT_CLIENT_7.png`
  }]
};
